<template>
  <div>
    <h1 class="page-title">Check-in</h1>

    <div class="search-box">
      <input class="input" type="text" v-model="searchQuery" placeholder="Buscar participante..." />
    </div>

    <SkeletonLoader v-if="store.loading" variant="table-row" :count="6" />

    <div class="checkin-list" v-else-if="filteredPending.length > 0">
      <div class="checkin-item card" v-for="item in filteredPending" :key="item.id">
        <div class="checkin-info">
          <span class="checkin-name">{{ item.name }}</span>
          <span class="checkin-meta">{{ item.leader }} · {{ item.city || '-' }}</span>
        </div>
        <button
          class="btn-checkin"
          @click="handleCheckin(item)"
          :disabled="loadingId === item.id"
        >
          <svg v-if="loadingId !== item.id" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41L9 16.17z"/></svg>
          <span v-if="loadingId !== item.id">Check-in</span>
          <span v-else>...</span>
        </button>
      </div>
    </div>

    <EmptyState
      v-else
      title="Todos confirmados!"
      description="Nao ha participantes pendentes de check-in."
    />
  </div>
</template>

<script>
import { useParticipantsStore } from '../stores/participants'
import SkeletonLoader from '../components/ui/SkeletonLoader.vue'
import EmptyState from '../components/ui/EmptyState.vue'

export default {
  name: 'CheckInPage',
  components: { SkeletonLoader, EmptyState },
  data() {
    return { searchQuery: '', loadingId: null }
  },
  computed: {
    store() { return useParticipantsStore() },
    filteredPending() {
      const items = this.store.pending
      if (!this.searchQuery.trim()) return items
      const q = this.searchQuery.toLowerCase()
      return items.filter(i => i.name.toLowerCase().includes(q))
    }
  },
  methods: {
    async handleCheckin(item) {
      this.loadingId = item.id
      try {
        await this.store.checkin(item.id)
      } catch {
        this.$toast.open({ message: 'Erro ao realizar check-in', type: 'error', position: 'top-right', duration: 5000 })
      } finally {
        this.loadingId = null
      }
    }
  }
}
</script>

<style scoped>
.search-box {
  max-width: 400px;
  margin-bottom: var(--spacing-base);
}
.checkin-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}
.checkin-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-base);
  transition: var(--transition-fast);
}
.checkin-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}
.checkin-name {
  font-size: var(--text-md);
  font-weight: 600;
  color: var(--color-text-primary);
}
.checkin-meta {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
.btn-checkin {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: 8px 16px;
  background: var(--color-success);
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
  white-space: nowrap;
}
.btn-checkin:hover { background: #27ae60; box-shadow: var(--shadow-button); }
.btn-checkin:disabled { opacity: 0.6; cursor: wait; }
</style>
